export const INPUT_SIZE_MAP = {
	DEFAULT: `input f5`,
	SMALL: `input-small f6`,
	LARGE: `input-large f5`
};

export type InputSize = keyof typeof INPUT_SIZE_MAP;
